const setBulkAttr = (element, collection) => {
  const jqElement = $(element);
  for (const [key, value] of Object.entries(collection)) {
    if (value === null) {
      jqElement.removeAttr(key);
    } else {
      jqElement.attr(key, value);
    }
  }
};

function showFieldType(value) {
  var element = $("#user_value_value");
  if (!element.length) return;

  element.removeClass("form-check-input");
  element.addClass("form-control");

  switch (value) {
    case "date":
      setBulkAttr(element, {
        type: "date",
        order: "day month year",
        step: null,
        pattern: null,
      });
      break;
    case "datetime":
      setBulkAttr(element, {
        type: "datetime-local",
        order: "day month year",
        step: null,
        pattern: null,
      });
      break;
    case "boolean":
      const checked = element.val() === "True" || element.val() === "true";
      element.removeClass("form-control");
      element.addClass("form-check-input");
      setBulkAttr(element, {
        type: "checkbox",
        value: "true",
      });
      element.prop("checked", checked);
      break;
    case "integer":
      setBulkAttr(element, {
        type: "number",
        order: null,
        pattern: "^/[0-9]|./$",
        value: parseInt(element.val()) || "0",
      });
      break;
    case "float":
      setBulkAttr(element, {
        type: "number",
        order: null,
        step: "0.01",
        value: parseFloat(element.val()).toFixed(2) || "0.00",
      });
      break;
    default:
      setBulkAttr(element, {
        type: "text",
        order: null,
        step: null,
        pattern: null,
      });
      element.prop("checked", false);
  }
}

function initializeUserValueFields() {
  const value = $("#user_value_data_type").val();
  showFieldType(value);

  $(document).off("change.userValueFields", "#user_value_data_type");
  $(document).on("change.userValueFields", "#user_value_data_type", (element) => {
    showFieldType(element.target.value);
  });
}

$(initializeUserValueFields);
document.addEventListener("turbo:load", initializeUserValueFields);
document.addEventListener("turbolinks:load", initializeUserValueFields);
